import { useState } from 'react';
import { MESSAGES } from './sign-in';

/**
 * One request at a time, with its failure as a line of text. `run` resolves to
 * the message to show, or `undefined` when it worked.
 */
export function useAttempt(): {
  error: string;
  setError: (error: string) => void;
  busy: boolean;
  attempt: (run: () => Promise<string | undefined>) => Promise<boolean>;
} {
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const attempt = async (run: () => Promise<string | undefined>): Promise<boolean> => {
    setBusy(true);
    setError('');
    try {
      const failure = await run();
      if (failure !== undefined) setError(failure);
      return failure === undefined;
    } catch {
      setError(MESSAGES.failed);
      return false;
    } finally {
      setBusy(false);
    }
  };

  return { error, setError, busy, attempt };
}
